import { render, staticRenderFns } from "./classType.vue?vue&type=template&id=a25dfd96&"
import script from "./classType.vue?vue&type=script&lang=js&"
export * from "./classType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports